import * as Dfns from 'date-fns/fp';
import {
  CompanyFiscalCal,
  getEndOfFiscalMonth,
  getStartOfFiscalMonth,
  getStartOfFiscalMonthLabel,
  getStartOfFiscalYearLabel
} from '@blisspointmedia/bpm-types/dist/FiscalCalendar';
import { DATE_FORMAT, makeMemoizedGetter } from '../../../utils/data';
import { MonthInfo } from '../date-picker-types';

const format = Dfns.format(DATE_FORMAT);

export const getMonthInfo = makeMemoizedGetter({
  calculate: (date: Date, fiscalCal: CompanyFiscalCal): MonthInfo => {
    const startOfMonth = getStartOfFiscalMonth(date, fiscalCal);
    const endOfMonth = getEndOfFiscalMonth(date, fiscalCal);
    const dowStart = Dfns.getDay(startOfMonth);
    const dowEnd = Dfns.getDay(endOfMonth);
    const dates = Dfns.eachDayOfInterval({
      start: startOfMonth,
      end: endOfMonth
    }).map(rawDate => {
      const formatted = format(rawDate);
      return { date: formatted, display: Dfns.format('d', rawDate) };
    });
    const sow = fiscalCal.startOfWeek || 0; // default to sunday, eventhough we're calling monday the default for date grouping

    dates.unshift(...new Array((dowStart + (7 - sow)) % 7).fill(null));
    dates.push(...new Array(6 - ((dowEnd + (7 - sow)) % 7)).fill(null));

    return {
      year: parseInt(Dfns.format('yyyy', getStartOfFiscalYearLabel(date, fiscalCal)), 10) || 2020,
      dates,
      date: startOfMonth
    };
  },
  makeKey: (val, fiscalCal) => {
    // Key on every calendar field except generatedPatternCal.
    const { generatedPatternCal, ...calKey } = fiscalCal;
    return `${Dfns.format('yyyy-MM')(getStartOfFiscalMonthLabel(val, fiscalCal))}|${JSON.stringify(calKey)}`;
  }
});
